import { createSlice } from "@reduxjs/toolkit";

const checkOpenedReportSlice = createSlice({
  name: "checkOpenedReportSlice",
  initialState: false,
  reducers: {
    setCheckOpenedReportLoadStatus: (_, action) => action.payload,
  },
});

export const { setCheckOpenedReportLoadStatus } =
  checkOpenedReportSlice.actions;

export default checkOpenedReportSlice.reducer;
